import RelatorioListarTurmaPage from "@/Pages/Relatorios/ListarTurmaPage.vue";
import lancarRelatorioBNCCPage from "@/Pages/Relatorios/lancarRelatorioBNCCPage.vue";
import lancarRelatorioDescritivoPage from "@/Pages/Relatorios/lancarRelatorioDescritivoPage.vue";
import relatorioPage from "@/Pages/Relatorios/index.vue";

export default [
  {
    path: "/relatorios/:franquiaId",
    name: "relatorios",
    component: relatorioPage,
  },
  {
    path: "/relatorios/visualizar/:gestaoDeAulasId/:turmaId",
    name: "relatorios.visualizar",
    component: RelatorioListarTurmaPage,
  },
  {
    path: "/relatorios/lancarRelatorioBNCC/:matricula_id",
    name: "relatorios.lancarRelatorioBNCC",
    component: lancarRelatorioBNCCPage,
  },
  {
    path: "/relatorios/lancarRelatorioDescritivo/:matricula_id",
    name: "relatorios.lancarRelatorioDescritivo",
    component: lancarRelatorioDescritivoPage,
  },
];
